import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { get, valuesIn, reduce, find, join, isEmpty } from 'lodash';
import prettyPhone from '../../../lib/prettyPhone';
import { formatCompanyUrlForHyperlink, extractCompanyUrlFromEmail } from '../../../lib/formatCompanyUrl';

import {lookup, } from '../../../redux/helpers/staticData';
import * as syncActions from '../../../redux/actionCreators/sync';

import Button from '../../../common/components/Button';
import ContactTable from '../../../common/components/ContactTable';

@connect((state) => ({
  contact   : state.contactProfile,
  company   : state.company,
  staticData: state.staticData,
  labels    : state.labels,
  jobs      : valuesIn(state.jobRequests),
  contacts  : valuesIn(state.companyContacts),
  bqpMigrationFeature: state.staticData.featureToggles.find(feature => feature.hardcodelink === 'BQP_MIGRATION_FEATURE').value === true,
}))
export default class CompanyDashboard extends React.Component {
  static propTypes = {
    dispatch   : PropTypes.func.isRequired,
    contact    : PropTypes.object.isRequired,
    company    : PropTypes.object.isRequired,
    contacts   : PropTypes.array.isRequired,
    staticData : PropTypes.object.isRequired,
    labels     : PropTypes.object.isRequired,
    bqpMigrationFeature : PropTypes.bool
  }

  constructor(props, context) {
    super(props, context);
    this.getCompanyUrl = ::this.getCompanyUrl;
    const initialState = {};

    this.state = initialState;
  }

  componentDidMount() {
    this.props.dispatch(syncActions.setNavState({isOpen: true, hideClose: true}));
  }

  showSelectedValues(type, ids) {
    const values = reduce(this.props.staticData[type], (values, dataObj) => {
      if (!values) {
        values = [];
      }

      if (find(ids, (item) => dataObj.id === item || dataObj.value === item)) {
        values.push(dataObj.name || dataObj.primaryText);
      }
      return values;
    }, []);

    return join(values, ', ');
  }


  getCompanyUrl() {
    if (this.props.company.website) {
      return formatCompanyUrlForHyperlink(this.props.company.website);

      // eslint-disable-next-line no-else-return
    } else {
      if (isEmpty(this.props.contact)) {
        return '';

        // eslint-disable-next-line no-else-return
      } else {
        const contactEmail = this.props.contact.user.email;
        return extractCompanyUrlFromEmail(contactEmail);
      }
    }
  }

  render() {

    const { CompanyCard } = this.props.labels;
    const company = this.props.company;
    const companyHyperlink = this.getCompanyUrl();
    return (
      <div className='company-dashboard'>
        <div className='top-info-section'>
          {get(company, 'relationshipManagerId', null)
            &&
            <div data-id='Relationship Manager'>
              <span className='heavy-text'>{ get(this.props.staticData, 'account.name') }</span>
              <span>{company.relationshipManager.name}, Relationship Manager • </span>
              <span>{company.relationshipManager.phone && (`${prettyPhone(company.relationshipManager.phone)} • `)}</span>
              <span>{company.relationshipManager.email}</span>
            </div>
          }
        </div>

        <div className='grid company-dashboard-header'>

          <div className='row'>
            <div className='col'>
               <h1 data-id='Company Name'>{get(company, 'name')}</h1>
            </div>
            {
              !this.props.bqpMigrationFeature &&
              <div className='col buttons-container'>
                    <Button
                      data-id='tech-button'
                      className='button-secondary'
                      onClick={() => this.props.dispatch(push('/client/company/tech'))}
                      label='Tech Q&A' />
                    <Button
                      data-id='edit-button'
                      className='button-secondary'
                      onClick={() => this.props.dispatch(push('/client/company/edit'))}
                      label='Edit Info'
                    />
                </div>
            }
            </div>
          </div>

        <div className='card-details'>
          <div className='center-column-1'>
            <span data-id='Address'>{get(company, 'address')} {get(company, 'address2')}<br /></span>
            <span data-id='City State Zip'>{get(company, 'city')}, {lookup(this.props.staticData, 'stateList', {id: get(company, 'state')}, 'abbreviation')} {get(company, 'zip')}<br /></span>
            <span data-id='Phone'>{company.phoneNumber && prettyPhone(get(company, 'phoneNumber'))}<br /></span>
            <span data-id='Number Employees'># of Employees: {get(company, 'numberOfEmployees')}<br /></span>
            <span data-id='Number Offices'># of Offices: {get(company, 'numberOfOffices')}<br /></span>
          </div>
          <div className='center-column-1'>
            <span data-id='Firm Type'><span className='heavy-text'>{CompanyCard.industry}</span> {this.showSelectedValues('industryTypesList', get(company, 'industryTypes'))}<br /></span>
            <span data-id='Industry Segment'><span className='heavy-text'>Industry Segment:</span> {this.showSelectedValues('segmentTypes', get(company, 'segmentTypes'))}<br /></span>
            <span data-id='Company Website'><span className='heavy-text'>Company Website:</span> <a href={`http://${companyHyperlink}`}>{company.website || companyHyperlink}</a><br /></span>
            {
              get(this.props.labels, 'tradeAssociations', '')
              &&
              <span data-id='Trade Associations'><span className='heavy-text'>{get(this.props.labels, 'tradeAssociations', '')}:</span> {this.showSelectedValues('tradeAssociations', get(company, 'tradeAssociations'))}<br /></span>
            }
            {/* <span data-id='Network Affiliations'><span className='heavy-text'>Network Affiliations:</span> <br /></span> */}
          </div>

        </div>

        <div className='summary-view contacts-section'>
          <h2>Contact Information</h2>
          <ContactTable
            contactLink={false}
            useContactTypeDropdown={true}
            contacts={this.props.contacts}
            showFilters={false}
            columns={['Name', 'Title', 'Email', 'Phone']}
            location={this.props.location.pathname} />
        </div>
      </div>

    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/client/CompanyDashboard/index.js